import Login from './views/Login.vue'
import NotFound from './views/404.vue'
// import Ulist from './views/user/Ulist.vue'

import Home from './views/Home.vue'

import PList from './views/Plist.vue'

import productLog from './views/sdkControl/productLog.vue'


import Creative from './views/adControl/Creative.vue'
import CreativeGroupList from './views/adControl/CreativeGroupList.vue'
import CreativeGroup from './views/adControl/CreativeGroup.vue'
import ADbanner from './views/adControl/ADbanner.vue'
import ADdelivery from './views/adControl/ADdelivery.vue'




import CData from './views/adData/cData.vue'
import ADData from './views/adData/adData.vue'
import PData from './views/adData/pData.vue'

import PData2 from './views/adData/pData2.vue'

import PData3 from './views/adData/pData3.vue'

//广告创意2
import CData2 from './views/adData/cData2.vue'

//广告创意 临时
import CData3 from './views/adData/cData3.vue'

import CDetail from './views/adData/cDetail.vue'
// import ADetail from './views/adData/adDetail.vue'

import SdkInfo from './views/sdkControl/sdkInfo.vue'
import SdkVersion from './views/sdkControl/sdkVersion.vue'

import sdkCreativeLogo from './views/sdkControl/sdkCreativeLogo.vue'
import sdkAdLogo from './views/sdkControl/sdkAdLogo.vue'
import incomeAutoLogo from './views/sdkControl/incomeAutoLogo.vue'


import echarts from './views/charts/echarts.vue'

import ruleList from './views/rules/Rlist';

import aldList from './views/rules/ALDlist'

import aldListDetail from './views/rules/ALDlistDetail'


import billCompanyList from './views/company/companylist'
import billDataList from './views/company/dataList'
import cpCompanyList from './views/company/cpcompanylist'

import billDataDetail from './views/company/dataDetail'

import deviceManagement from './views/setting/device.vue'
let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        leaf:true,
        component: Home,
        redirect:'product/index',
        name: '产品管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: 'product/index', component: PList, name: '产品管理' },
            { path: 'product/log/:index_id', component: productLog, name: '产品日志' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '广告管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: 'creative/index/:issued_app_id', component: Creative, name: '创意投放', },
            { path: 'creativeBale/index', component: CreativeGroupList, name: '创意组合列表' },
            { path: 'creativeBale/index/:index_id', component: CreativeGroup, name: '创意组合详情' },
            { path: 'plan/creative/:index_id', component: productLog, name: '创意投放日志' },
            { path: 'space/index/:issued_app_id', component: ADbanner, name: '广告位' },
            { path: 'space/log/:index_id', component: productLog, name: '广告位日志' },
            { path: 'plan/index', component: ADdelivery, name: '广告投放' },
            { path: 'plan/log/:index_id', component: productLog, name: '广告投放日志' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '广告数据',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            
           
            { path: 'creativeData/index', component: CData, name: '广告创意'},
            { path: 'creativeData/product', component: CData2, name: '广告创意2'},
            
            { path: 'creativeData/cindex', component: CData3, name: '广告创意'},
           
            { path: '/cDetail/:id', component: CDetail, name: '创意详情'},
            { path: 'spaceData/index', component: ADData, name: '广告位' },
           
            // { path: '/adDetail/:id', component: ADetail, name: '广告位详情'},
            { path: 'income/index', component: PData, name: '产品收入' },
            { path: 'income/product', component: PData2, name: '产品收入2' },
            
            { path: 'income/cindex', component: PData3, name: '产品收入' },
            
            
            
            
        ]
    },
    {
        path: '/',
        component: Home,
        name: 'SDK管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
        	{ path: 'shieldRule/index', component: ruleList, name: '屏蔽规则' },
        	{ path: 'shieldAld/index', component: aldList, name: '扣量规则' },
        	{ path: 'shieldAld/index/:index_id', component: aldListDetail, name: '扣量规则详情' },
            { path: 'version/index', component: SdkInfo, name: '版本信息' },
            { path: 'serving/index', component: SdkVersion, name: '投放列表' },
            { path: 'product/log/:index_id', component: productLog, name: '屏蔽日志' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '公司管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
        	{ path: 'billCompany/index', component: billCompanyList, name: '公司列表' },
        	{ path: 'billData/index', component: billDataList, name: '账单列表' },
        	{ path: 'billData/detail/:index_id', component: billDataDetail, name: '账单详情明细' },
        	{ path: 'cpCompany/index', component: cpCompanyList, name: '分成公司列表' },
        	
        ]
    },
    {
        path: '/',
        component: Home,
        name: '操作日志',
        iconCls: 'el-icon-setting',//图标样式class
        children: [
            { path: 'log/creativebale', component: sdkCreativeLogo, name: '创意组合日志' },
	        { path: 'log/plan', component: sdkAdLogo, name: '广告投放日志' },
	        {path: 'log/income_auto', component: incomeAutoLogo, name: '分配收入日志' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '系统设置',
        iconCls: 'el-icon-setting',//图标样式class
        children: [
            { path: 'setting/list', component:deviceManagement , name: '设备管理' },
        ]
    },
    
    

    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js